const formatDateTime = (iso) => {
    const d = new Date(iso);
    return d.toLocaleString("sv-SE", { timeZone: "Asia/Jakarta" }).replace("T", " ");
};

export default formatDateTime;